@if(show){
<div class="terms-container" id="scrollContainer"  [ngClass]="{
    'terms-modal-page': !commonService?.currentRoute?.includes('/terms-and-conditions')
  }">
  @if(this.commonService?.currentRoute?.includes('/terms-and-conditions')){
  <button type="button" class="btn-close float-end" aria-label="Close" [routerLink]="'/home'"></button>
  }
  <h1>Maisha HealthAi Terms and Conditions</h1>

  <h2>1. Activating Your Account</h2>
  <ul>
    <li>
      Health Tips service is open to all active Econet prepaid and EcoCash
      customers.
    </li>
    <li>
      To access the service, dial USSD short code. The customer will dial the
      short code *147# and access Maisha HealthAi services.
    </li>
    <li>
      The service enables qualifying mobile customers to have access to
      Maisha HealthAi services.
    </li>
    <li>
      By selecting the service, you agree to be automatically billed daily
      and/or weekly and/or monthly fees as indicated during registration and in
      accordance with your preferred package.
    </li>
  </ul>

  <h2>2. Fees and Charges</h2>
  <ul>
    <li>
      Subscription payments will be charged on a pre-paid basis from the day you
      sign up and will cover for the duration paid for.
    </li>
    <li>
      All the paid services will be rendered once subscription fee is deducted
      in full.
    </li>
    <li>
      If the amount in the account of consent is not enough for a single billing
      to occur, partial collections will be done until the total collected
      amount equates to the full required amount.
    </li>
    <li>
      If the amount in the ZWG account of consent is not enough, Maisha HealthAi
      reserves the right to collect from the corresponding USD account and
      vice-versa.
    </li>
    <li>
      Automatic Renewal – Subscribed packages will automatically be renewed
      unless the customer has opted out.
    </li>
    <li>
      Maisha HealthAi reserves the right to collect subscription/s from either the
      Airtime account and/or EcoCash wallet, notwithstanding the customers
      preferred payment source. This option will only be exercised.
    </li>
    <li>
      By subscribing to the Maisha HealthAi, you consent to the sharing of your data
      with our partners (Econet Wireless, EcoCash, Vaya, Steward Bank).
    </li>
    <li>
      Waiting period - The following services will have a 3-month waiting period
      before they are activated: Ambulance Services, Physical Consultations,
      Access to Drugs, Remote Consultations.
    </li>
    <li>
      All healthcare advisory services (tips) will be available from the first
      day of subscription.
    </li>
  </ul>

  <h2>3. Changes</h2>
  <ul>
    <li>
      Maisha HealthAi reserves the right to add more functions from time to time onto
      the Services and notify you of such additions through communication
      channels, such as but not limited to SMS.
    </li>
    <li>
      Maisha HealthAi reserves the right to increase tariffs in line with the
      inflationary environment and/or change the mode of payment.
    </li>
    <li>
      Maisha HealthAi may at any time amend rules and will give a reasonable notice
      of such amendments.
    </li>
  </ul>

  <h2>4. Termination</h2>
  <ul>
    <li>
      A subscriber may terminate subscription/s by dialling *147# and select an
      option to deactivate. Once a subscriber has terminated, auto collections
      will stop.
    </li>
    <li>
      If there are no transactions for a period of ninety (90) days, Maisha HealthAi
      will be entitled at its discretion to classify the account as being
      dormant. Should there be no activity for a period of more than 6 months
      Maisha HealthAi shall, at its discretion terminate the service.
    </li>
  </ul>

  <h2>5. Customer Service</h2>
  <ul>
    <li>
      In the event there is a failed delivery of service/s after funds have been
      deducted due to system errors, a refund will be processed and the same
      will apply in the event of multiple billing.
    </li>
    <li>All queries pertaining to the service subscriber may call 114.</li>
    <li>
      In a case that there is a promotion ongoing, and the customer registration
      details are different from the winning customer mobile number, the
      customer must produce an Affidavit where they have been given consent by
      the owner of that mobile number to use it. This process and verification
      is done with the assistance and guidance of the Econet Audit and Risk
      teams.
    </li>
  </ul>

  <h2>6. Disclaimer</h2>
  <p>
    Maisha HealthAi is not a substitute for professional advice, diagnosis or
    treatment. Subscribers should not ignore professional medical advice in
    seeking treatment because of Maisha HealthAi!
  </p>

  <h2>7. Privacy Policy</h2>
  <p>
    The Econet Wireless Zimbabwe Privacy Policy shall apply to this Service and
    by subscribing a customer agrees to the provisions thereof.
  </p>

  @if(!this.commonService?.currentRoute?.includes('/terms-and-conditions')){
  <div class="terms-footer">
    <button
      data-bs-dismiss="modal"
      class="btn done button_class"
      (click)="close()"
    >
      Okay
    </button>
  </div>
  }
</div>
}
